<template>
  <v-text-field
    v-model="params[searchTerm]"
    @click:clear="handleClearSearch"
    @keyup="handleSearch"
    :label="$t(`filters.${label}`)"
    :prepend-inner-icon="innerIcon"
    :type="type"
    clearable
    outlined
    small
    dense
  >
    <template v-slot:append>
      <v-icon v-if="icon !== ''" class="grey--text" @click="applyFilter()">
        mdi-{{ icon }}
      </v-icon>
    </template>
  </v-text-field>
</template>

<script>
import { mapMutations } from 'vuex'
import store from '@/store'

export default {
  name: 'FilterSearch',

  props: {
    fetchData: {
      type: Function,
      required: true,
    },

    searchTerm: {
      type: String,
      default: 'search',
    },

    label: {
      type: String,
      default: 'search',
    },

    type: {
      type: String,
      default: 'text',
    },

    icon: {
      type: String,
      default: '',
    },

    innerIcon: {
      type: String,
      default: ''
    }
  },

  methods: {
    ...mapMutations(['setFilters', 'setCurrentPage']),

    handleSearch() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }

      this.timer = setTimeout(() => {
        this.applyFilter()
      }, 1000)
    },

    applyFilter() {
      Promise.resolve(
        this.setFilters({ ...store.getters.filters, ...this.params })
      )
        .then(() => this.setCurrentPage(1))
        .then(() => this.fetchData())
    },

    handleClearSearch() {
      this.params[this.type] = ''
      setTimeout(() => {
        this.applyFilter()
      }, 100)
    },
  },

  data() {
    return {
      timer: null,
      params: {},
    }
  },
}
</script>
